import { render, staticRenderFns } from "./BranchesIndex.vue?vue&type=template&id=998ab962"
import script from "./BranchesIndex.vue?vue&type=script&lang=js"
export * from "./BranchesIndex.vue?vue&type=script&lang=js"
import style0 from "./BranchesIndex.vue?vue&type=style&index=0&id=998ab962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports